import { Autocomplete, Box, TextField } from '@mui/material';
import CustomLabel from 'components/customLabel';
import ErrorMessage from 'components/errorMessage';
import { SelectSumStyle, SelectSumStyle2, SelectSumStyle3 } from 'components/InitialStyle';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useCurrencyQuery } from 'services/query/currency/use-currency-list';

type ComponentType = {
  name: any;
  error: any;
  value?: any;
  control: any;
  label?: string;
  required?: boolean;
  defaultValue?: number | string;
};
interface SelectOption {
  label: string;
  value: string;
}

interface Specialist {
  id: string;
  name: string;
}

const SelectSum = ({
  label,
  name,
  value = '',
  control,
  error,
  defaultValue,
  required = true,
}: ComponentType) => {
  const { isLoading: currencyLoading, data: currencyData } = useCurrencyQuery();

  const currencyListData = useMemo<SelectOption[]>(() => {
    const list = Array.isArray(currencyData) ? currencyData : (currencyData?.results ?? []);
    return list.map((item: Specialist) => ({
      value: item.id,
      label: item.name,
    }));
  }, [currencyData]);

  const formatNumber = (value: any) => {
    const numericValue = value.replace(/\D/g, ''); // Faqat raqamlarni qoldirish
    return new Intl.NumberFormat('en-US', {
      useGrouping: true,
    })
      .format(numericValue)
      .replace(/,/g, ' '); // Virgullarni bo'sh joy bilan almashtirish
  };

  return (
    <>
      <CustomLabel htmlFor={label}>{label}</CustomLabel>
      <Box sx={{ display: 'flex' }}>
        <Controller
          name='currency'
          control={control}
          defaultValue={{ label: 'UZS', value: 1 }}
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              disableClearable
              sx={SelectSumStyle2}
              value={value || null}
              loading={currencyLoading}
              options={currencyListData}
              defaultValue={currencyListData[0]}
              isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
              onChange={(_, values) => {
                onChange(values || null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={SelectSumStyle3}
                  error={Boolean(error?.currency)}
                  helperText={error?.currency?.message}
                />
              )}
            />
          )}
        />

        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={{
            required: required && 'Поле, обязательное для заполнения',
          }}
          render={({ field }) => {
            const handleChange = (e: any) => {
              const inputValue = e.target.value.replace(/\s/g, ''); // Bo'sh joylarni olib tashlash
              const numericValue = parseInt(inputValue, 10); // Raqamni number tipiga aylantirish
              if (!isNaN(numericValue)) {
                field.onChange(numericValue);
              } else {
                field.onChange(''); // Notog'ri kirishda bo'sh qiymat uzatish
              }
            };

            return (
              <TextField
                {...field}
                type='text'
                sx={SelectSumStyle}
                error={error?.[name]}
                value={field.value !== undefined ? formatNumber(String(field.value)) : value}
                helperText={error?.[name]?.message}
                onChange={handleChange}
                onWheel={(e: any) => e.target.blur()}
              />
            );
          }}
        />
      </Box>
      <ErrorMessage error={error} name={name} />
    </>
  );
};

export default SelectSum;
